import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import PasswordField from "../components/PasswordField";
import { safeReturnUrl } from "../lib/safeReturnUrl";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(location.search);
  const redirect = safeReturnUrl(params.get("returnUrl") || location.state?.from, "/account");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back to TAVEN");
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid email or password");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-taven-gray/30" data-testid="login-page">
      <div className="w-full max-w-md bg-white border border-black/10 p-8 md:p-10">
        <div className="text-center mb-8">
          <span className="text-2xl font-black font-display tracking-tighter">TAVEN</span>
          <h1 className="text-xl font-black font-display mt-4">Sign in to your account</h1>
          <p className="text-sm text-muted-foreground mt-1">Access orders, courses, certificates & more.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="flex items-center border border-black/15 focus-within:border-taven-gold px-3">
            <Mail className="w-4 h-4 text-muted-foreground" />
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email" className="w-full px-3 py-3.5 text-sm outline-none" />
          </div>
          <PasswordField value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" testId="login-password" />
          <button disabled={loading} data-testid="login-submit" className="w-full bg-taven-black text-white font-bold uppercase tracking-wider py-4 hover:bg-taven-orange transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          <Link to="/forgot-password" className="text-taven-gold hover:underline" data-testid="forgot-link">Forgot password?</Link>
        </div>
        <p className="mt-6 text-center text-sm text-muted-foreground">
          New to TAVEN? <Link to="/register" state={{ from: redirect }} className="font-bold text-black hover:text-taven-gold" data-testid="to-register">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
